import type { ManualRFQ } from './types';

interface ManualRFQAction {
  type: 'quote' | 'fix';
  disabled: boolean;
}

export function getManualRFQActions(manualRFQ: ManualRFQ): ManualRFQAction[] {
  if (manualRFQ.isOpen) {
    // Open RFQs can be rejected, and answered
    return [
      {
        type: 'quote',
        disabled: false,
      },
    ];
  }

  if (manualRFQ.canFixQuote) {
    return [
      {
        type: 'fix',
        disabled: false,
      },
    ];
  }

  // If there is nothing actionable, we default to returning the Reject and Quote buttons, but disabled
  return [
    {
      type: 'quote',
      disabled: true,
    },
  ];
}
